import internalChatDraftsAPI from 'dashboard/api/internalChatDrafts';

const state = {
  // array of draft objects { channel_id, content, parent_id? }
  drafts: [],
  uiFlags: { isFetching: false, isSaving: false },
};

const getters = {
  getDrafts: s => s.drafts,
  getUIFlags: s => s.uiFlags,
  getDraftByChannelId: s => channelId =>
    s.drafts.find(d => d.channel_id === channelId && !d.parent_id) || null,
  getThreadDraft: s => (channelId, parentId) =>
    s.drafts.find(d => d.channel_id === channelId && d.parent_id === parentId) || null,
  getThreadDraftParentIds: s => channelId =>
    s.drafts
      .filter(d => d.channel_id === channelId && d.parent_id)
      .map(d => d.parent_id),
};

const mutations = {
  SET_UI_FLAGS(s, flags) {
    s.uiFlags = { ...s.uiFlags, ...flags };
  },
  SET_DRAFTS(s, drafts) {
    s.drafts = drafts;
  },
  UPSERT_DRAFT(s, draft) {
    const idx = s.drafts.findIndex(
      d => d.channel_id === draft.channel_id && d.parent_id === draft.parent_id
    );
    if (idx !== -1) {
      s.drafts = s.drafts.map((d, i) => (i === idx ? draft : d));
    } else {
      s.drafts = [...s.drafts, draft];
    }
  },
  REMOVE_DRAFT(s, { channelId, parentId }) {
    s.drafts = s.drafts.filter(
      d => !(d.channel_id === channelId && d.parent_id === parentId)
    );
  },
};

const actions = {
  async fetchDrafts({ commit }) {
    commit('SET_UI_FLAGS', { isFetching: true });
    try {
      const { data } = await internalChatDraftsAPI.getDrafts();
      commit('SET_DRAFTS', data?.data || data || []);
    } finally {
      commit('SET_UI_FLAGS', { isFetching: false });
    }
  },

  async saveDraft({ commit }, { channelId, content, parentId }) {
    commit('SET_UI_FLAGS', { isSaving: true });
    try {
      await internalChatDraftsAPI.saveDraft(channelId, {
        content,
        parent_id: parentId || null,
      });
      commit('UPSERT_DRAFT', {
        channel_id: channelId,
        content,
        parent_id: parentId || null,
      });
    } finally {
      commit('SET_UI_FLAGS', { isSaving: false });
    }
  },

  async deleteDraft({ commit }, { channelId, parentId }) {
    await internalChatDraftsAPI.deleteDraft(channelId, { parentId });
    commit('REMOVE_DRAFT', { channelId, parentId: parentId || null });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
